import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { PengaturanComponent } from './pengaturan.component';
import { PinComponent } from './pages/pin/pin.component';
import { PengaturanRoutingModule } from './pengaturan-routing.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileComponent } from './pages/profile/profile.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { ModalBuatPinComponent } from './components/modal-buat-pin/modal-buat-pin.component';
import { RekeningComponent } from './pages/rekening/rekening.component';
import { ModalPinComponent } from './pages/profile/components/modal-pin-verification/modal-pin-verification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ChangePasswordComponent } from './pages/profile/pages/change-password/change-password.component';
import { ModalChangeNumberComponent } from './pages/profile/components/modal-change-number/modal-change-number.component';
import { ModalVerifOTPComponent } from './pages/profile/components/modal-verif-otp/modal-verif-otp.component';
import { ModalDeletePhotoComponent } from './pages/profile/components/modal-delete-photo/modal-delete-photo.component';
import { ProfileGeneralComponent } from './pages/profile/components/profile-general/profile-general.component';
import { ModalViewKeyComponent } from './pages/profile/components/modal-view-key/modal-view-key.component';
import { ModalAddReferrerComponent } from './pages/profile/components/modal-add-referrer/modal-add-referrer.component';
import { ModalAddMobKeyComponent } from './pages/profile/components/modal-add-mob-key/modal-add-mob-key.component';
import { ModalInputNumberComponent } from './pages/profile/components/modal-input-number/modal-input-number.component';
import { ModalDeleteReferrerComponent } from './pages/profile/components/modal-delete-referrer/modal-delete-referrer.component';
import localeDe from '@angular/common/locales/de';
import { ModalAddWebhookComponent } from './pages/profile/components/modal-add-webhook/modal-add-webhook.component';
import { DocumentComponent } from './pages/document/document.component';
import { SlaDataInputComponent } from './pages/document/pages/sla-data-input/sla-data-input.component';
import { BusinessInformationInputComponent } from './pages/document/pages/sla-data-input/components/business-information-input/business-information-input.component';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { BusinessQuestionaireInputComponent } from './pages/document/pages/sla-data-input/components/business-questionaire-input/business-questionaire-input.component';
import { BusinessEscalationInputComponent } from './pages/document/pages/sla-data-input/components/business-escalation-input/business-escalation-input.component';
import { ServiceUsageInputComponent } from './pages/document/pages/sla-data-input/components/service-usage-input/service-usage-input.component';
import { SlaSubmissionComponent } from './pages/document/pages/sla-submission/sla-submission.component';
import { CaDataInputComponent } from './pages/document/pages/ca-data-input/ca-data-input.component';
import { CaSubmissionComponent } from './pages/document/pages/ca-submission/ca-submission.component';
import { UatInputComponent } from './pages/document/pages/uat-input/uat-input.component';
import { UatDestinationComponent } from './pages/document/pages/uat-input/components/uat-destination/uat-destination.component';
import { UatCalculateShippingComponent } from './pages/document/pages/uat-input/components/uat-calculate-shipping/uat-calculate-shipping.component';
import { UatOrderComponent } from './pages/document/pages/uat-input/components/uat-order/uat-order.component';
import { UatPickupComponent } from './pages/document/pages/uat-input/components/uat-pickup/uat-pickup.component';
import { UatPrintLabelComponent } from './pages/document/pages/uat-input/components/uat-print-label/uat-print-label.component';
import { UatHistoryAwbComponent } from './pages/document/pages/uat-input/components/uat-history-awb/uat-history-awb.component';
import { TeamsComponent } from './pages/teams/teams.component';
import { AddTeamComponent } from './pages/teams/pages/add-team/add-team.component';
import { DeleteTeamComponent } from './pages/teams/components/delete-team/delete-team.component';
import { VerificationTeamComponent } from './pages/teams/pages/verification-team/verification-team.component';
import { VerificationSuccessComponent } from './pages/teams/pages/verification-success/verification-success.component';
import { ExpeditionComponent } from './pages/expedition/expedition.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";
import { ColorSketchModule } from 'ngx-color/sketch';
import { LibsModule } from "src/app/libs/libs.module";
import { ShippingDeliveryComponent } from './pages/document/components/shipping-delivery/shipping-delivery.component';
import { PaymentServiceDocumentComponent } from './pages/document/components/payment-service/payment-service.component';
import { RouterOutlet } from '@angular/router';
import { QrislyServiceDocComponent } from './pages/document/components/qrisly-service-doc/qrisly-service-doc.component';
import { ModalDocInfoComponent } from './pages/document/components/modal-doc-info/modal-doc-info.component';
import { SlaDataInputQrislyComponent } from './pages/document/pages/sla-data-input-qrisly/sla-data-input-qrisly.component';
import { SlaSubmissionQrislyComponent } from './pages/document/pages/sla-submission-qrisly/sla-submission-qrisly.component';
import { UatInputPaymentComponent } from './pages/document/pages/uat-input-payment/uat-input-payment.component';
import { UatPaymentMethodComponent } from './pages/document/pages/uat-input-payment/components/uat-payment-method/uat-payment-method.component';
import { UatCreateVaComponent } from './pages/document/pages/uat-input-payment/components/uat-create-va/uat-create-va.component';
import { UatCreateQrisComponent } from './pages/document/pages/uat-input-payment/components/uat-create-qris/uat-create-qris.component';
import { UatStatusPaymentComponent } from './pages/document/pages/uat-input-payment/components/uat-status-payment/uat-status-payment.component';
import { UatCancelPaymentComponent } from './pages/document/pages/uat-input-payment/components/uat-cancel-payment/uat-cancel-payment.component';
import { RekeningItemComponent } from './pages/rekening/components/rekening-item/rekening-item.component';
import { RekeningFormComponent } from './pages/rekening/components/rekening-form/rekening-form.component';
registerLocaleData(localeDe);

@NgModule({
  declarations: [
    PengaturanComponent,
    PinComponent,
    ProfileComponent,
    RekeningComponent,
    ModalPinComponent,
    ModalBuatPinComponent,
    ChangePasswordComponent,
    ModalChangeNumberComponent,
    ModalVerifOTPComponent,
    ModalDeletePhotoComponent,
    ProfileGeneralComponent,
    ModalViewKeyComponent,
    ModalAddReferrerComponent,
    ModalAddMobKeyComponent,
    ModalInputNumberComponent,
    ModalDeleteReferrerComponent,
    ModalAddWebhookComponent,
    DocumentComponent,
    SlaDataInputComponent,
    BusinessInformationInputComponent,
    BusinessQuestionaireInputComponent,
    BusinessEscalationInputComponent,
    ServiceUsageInputComponent,
    SlaSubmissionComponent,
    CaDataInputComponent,
    CaSubmissionComponent,
    UatInputComponent,
    UatDestinationComponent,
    UatCalculateShippingComponent,
    UatOrderComponent,
    UatPickupComponent,
    UatPrintLabelComponent,
    UatHistoryAwbComponent,
    TeamsComponent,
    AddTeamComponent,
    DeleteTeamComponent,
    VerificationTeamComponent,
    VerificationSuccessComponent,
    ExpeditionComponent,
    PaymentComponent,
    ShippingDeliveryComponent,
    PaymentServiceDocumentComponent,
    QrislyServiceDocComponent,
    ModalDocInfoComponent,
    SlaDataInputQrislyComponent,
    SlaSubmissionQrislyComponent,
    UatInputPaymentComponent,
    UatPaymentMethodComponent,
    UatCreateVaComponent,
    UatCreateQrisComponent,
    UatStatusPaymentComponent,
    UatCancelPaymentComponent,
    RekeningItemComponent,
    RekeningFormComponent
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }],
  imports: [
    CommonModule,
    PengaturanRoutingModule,
    NgbModalModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AntDModule,
    NgbModule,
    NgSelectModule,
    CdkCopyToClipboard,
    ColorSketchModule,
    LibsModule,
    RouterOutlet
  ],
})
export class PengaturanModule { }
